import { Component, EventEmitter, Input, Output } from '@angular/core';

import { PrivaAction } from '@priva/components/action-menu';
import { PrivaButtonComponent } from '@priva/components/button';
import { PrivaHeaderComponent } from '@priva/components/header';
import { PrivaTitleSize } from '@priva/components/title';
import { PrivaLocalizationModule } from '@priva/localization';
import { PrivaTheme } from '@priva/styles/foundation';

@Component({
    selector: 'gm-status-error-page',
    templateUrl: 'status-error-page.component.html',
    imports: [PrivaButtonComponent, PrivaHeaderComponent, PrivaLocalizationModule],
})
export class StatusErrorPageComponent {
    @Input() title: string | undefined;
    @Input() info: string | undefined;
    @Input() extraInfo: string | undefined;
    @Input() actions: PrivaAction[] | undefined;

    @Input() actionTitle: string | undefined;
    @Input() actionHtmlId: string | undefined;
    @Input() actionHtmlClass: string | undefined;
    @Input() actionIcon: string | undefined;
    @Output() actionClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

    isExpanded = false;
    PrivaTitleSize = PrivaTitleSize;
    PrivaTheme = PrivaTheme;

    get hasExtraInfo(): boolean {
        return !!this.extraInfo;
    }

    actionButtonClick() {
        this.actionClicked.emit(true);
    }
}
